import { omit } from 'lodash';

import { DocumentSearchScopeType } from 'generated/bffDocument/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import dayjs from 'helpers/dayjs';

import { ChannelType } from 'models/ChannelType';
import { ExtendedDocumentsFilter } from 'models/Document';
import { Pagination } from 'models/Pagination';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

const filterMap: Record<string, string> = {
  phoneNum: 'serviceId',
  birthNum: 'birthNumber',
  idNum: 'companyRegNo',
  cuNum: 'cuRefNo',
  templateId: 'documentSubtype',
  orderNum: 'orderRefNo',
};

export const api = {
  getDocumentList: (
    url: string,
    filter: ExtendedDocumentsFilter,
    pagination: Pagination
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/document/documents`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        searchScope: DocumentSearchScopeType.LISTING_INT,
        ...Object.keys(filter).reduce(
          (obj, key) => ({
            ...obj,
            [filterMap[key] || key]: filter[key as keyof ExtendedDocumentsFilter],
          }),
          {}
        ),
        dateFrom: filter.dateFrom ? dayjs(filter.dateFrom).local().startOf('day').format() : undefined,
        dateTo: filter.dateTo ? dayjs(filter.dateTo).local().endOf('day').format() : undefined,
        ...omit(pagination, ['initPages']),
        forceCheck: false,
      },
    }),

  downloadDocument: (url: string, documentGUID: string, objectStoreName = 'OMS'): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/document/documents`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        searchScope: DocumentSearchScopeType.DETAIL_WITH_URL,
        documentGUID: documentGUID,
        objectStoreName: objectStoreName,
        forceCheck: true,
      },
    }),

  getDocumentListToFile: (
    url: string,
    filter: ExtendedDocumentsFilter,
    fileType: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/document/documents-to-file`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        searchScope: DocumentSearchScopeType.LISTING_INT,
        ...Object.keys(filter).reduce(
          (obj, key) => ({
            ...obj,
            [filterMap[key] || key]: filter[key as keyof ExtendedDocumentsFilter],
          }),
          {}
        ),
        dateFrom: filter.dateFrom ? dayjs(filter.dateFrom).local().startOf('day').format() : undefined,
        dateTo: filter.dateTo ? dayjs(filter.dateTo).local().endOf('day').format() : undefined,
        fileType,
        forceCheck: false,
      },
    }),
};
